import { Scope3Category } from '@app/ccf/company-report/scopes';
import React from 'react';
import { Badge } from '../ui/badge';

interface Scope3CategoryBadgeProps {
  category: Scope3Category | Scope3Category[];
  size?: 'sm' | 'md';
  className?: string;
}

const getCategoryLabel = (category: Scope3Category | Scope3Category[]) => {
  switch (category) {
    case 'purchased-goods':
      return 'Purchased Goods & Services';
    case 'supply-chain-logistics':
      return [
        'Upstream Transportation & Distribution',
        'Downstream Transportation & Distribution',
      ];

    default:
      return '';
  }
};

const Scope3CategoryBadge: React.FC<Scope3CategoryBadgeProps> = ({
  category,
  size = 'md',
  className,
}) => {
  if (Array.isArray(getCategoryLabel(category))) {
    const labels = getCategoryLabel(category) as string[];
    return (
      <div className={className}>
        {labels.map((label, index) => (
          <Badge key={index} variant="primary" size={size} className="mr-2">
            {label}
          </Badge>
        ))}
      </div>
    );
  }

  return (
    <Badge className={className} variant="primary" size={size}>
      {getCategoryLabel(category)}
    </Badge>
  );
};

export default Scope3CategoryBadge;
